import axios from 'axios'
import store from '@/store';
import {
    Toast
} from 'vant';


// const hostList = {
//     '9350': 'http://106.14.243.20:9350',
//     '9110': 'http://pcwallpaper.upupoo.com'
// }
const hostList = {
  // '9350': 'http://share.52puwan.com',
  '9350': 'http://share.upupoo.com',
  '9400': 'http://appwallpaper.upupoo.com',
  '9500': 'http://pcwallpaper.upupoo.com'
  
}
const askList = []

const service = axios.create({
    baseURL: 'http://share.upupoo.com',
    timeout: 30000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json',
    }
})

window._axiosPromiseArr = []
service.interceptors.request.use(config => {
    // if (!screenIsWhiteRouter(whiteList, config.url)) {

    // }
    if (config.headers.port) {
        config.url = hostList[config.headers.port] + config.url;
    }
    if (config.url && askList.every(item => !config.url.includes(item))) {
        config.cancelToken = new axios.CancelToken(cancel => {
            window._axiosPromiseArr.push({
                cancel
            })
        })
    } else {

    }

    return config
}, error => {
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        //console.log(res)
        if (res.success) {
            if (res.code && res.code !== 'success') {
                if (res.code === -1) {
                    // router.replace({path: '/page_drop'})
                } else {

                }
                return Promise.reject(new Error(res.msg));
            } else {
                return res;
            }
        } else {
            if (res.code == 'login') {
                Toast(res.message)
                store.dispatch('user/logoutAct')
            } else if (res.code == 'Token10003') {
                Toast(res.message)
                store.dispatch('user/logoutAct')
            } else {
                Toast(res.message)
            }
            return Promise.reject(res);
        }

    },
    error => {
        let originalRequest = error.config
        if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
            return Promise.reject('超时')
        } else if (error.message === 'Network Error') {
            return Promise.reject('无网')
        } else if (error.response) {
            const res = error.response.data
            if (res.status == '404') {}
            return Promise.reject(res)
        } else {
            return Promise.reject(error)
        }
    }
)


export default service